import BaseModel from '../../base';

export default class Variable extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.name = item.name;
    this.value = item.value;
    this.group = item.group || 'standard';
    this.source_level = item.source_level;
    this.is_system_allowed = item.is_system_allowed;
    this.attribute_id = item.attribute_id;
  }
}
